import React from "react";
import { ActionButton } from "../../helper/ImageFormat";
import Spinner from "../../Components/spinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import RateAction from "./RateAction";

const ShippingTable = ({
 loading,
 shippingZonedata,
 handleEditClick,
 handleDelete,
 toggleExpand,
 expandedRow,
 handletoggleShippingRate,
 toggleModal,
 handleEditShippingRateClick,
 handleshippingRateDelete,
}) => {
 const Tableheader = ["Zone Name", "Countries", "Rate", "Action"];
 return (
  <div className="row" style={{ marginTop: "10px" }}>
   <div className="col-md-12 grid-margin stretch-card">
    <div className="card">
     <div className="card-body">
      <div className="pb-20 table-responsive ">
       <table className=" custom-table table" id="myTable">
        <thead>
         <tr>
          {Tableheader &&
           Tableheader.length > 0 &&
           Tableheader.map((item, index) => (
            <th key={index} className="text-center">
             {item}
            </th>
           ))}
         </tr>
        </thead>
        <tbody>
         {loading ? (
          <tr>
           <td colSpan="7" className="text-center">
            <Spinner />
           </td>
          </tr>
         ) : shippingZonedata.length > 0 ? (
          shippingZonedata.map((item, index) => (
           <React.Fragment key={index}>
            <tr>
             <td className="text-center">{item.name}</td>
             <td style={{ width: "30%" }} className="text-center">
              {item?.countries && (
               <div
                style={{
                 display: "flex",
                 gap: "5px",
                 justifyContent: "center",
                 flexWrap: "wrap",
                }}
               >
                {item.countries.map((country, idx) => (
                 <span key={idx}>{country},</span>
                ))}
               </div>
              )}
             </td>

             <td className="text-center">
              <div onClick={() => toggleExpand(item.id)}>
               <i className="fa-solid fa-circle-chevron-down"></i>
              </div>
             </td>

             <td style={{display:"flex",justifyContent:"center"}}>
              <ActionButton
               data={item}
               handleEditClick={handleEditClick}
               handleDelete={handleDelete}
               module={"Shipping zone"}
              />
             </td>
            </tr>

            {expandedRow === item.id && (
             <tr>
              <td colSpan="5">
               <div className="p-3 bg-light border rounded">
                <div
                 style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "10px",
                 }}
                >
                 <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="plus-tooltip">Add Rate</Tooltip>}
                 >
                  <div
                   onClick={handletoggleShippingRate}
                   style={{
                    height: "20px",
                    width: "20px",
                    background: "#656CD9",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "17px",
                    color: "#fff",
                    cursor: "pointer",
                   }}
                  >
                   <i
                    className="fa-solid fa-plus"
                    style={{ fontSize: "10px" }}
                   ></i>
                  </div>
                 </OverlayTrigger>
                </div>

                <div className="row">
                 {item?.ShippingZoneAddRate?.length > 0 ? (
                  item.ShippingZoneAddRate.map((rate, idx) => (
                   <div key={idx} className="col-md-6  mb-0 ">
                    <div
                     className="card shadow-lg"
                     style={{ marginTop: "10px" }}
                    >
                     <div
                      className="card-body"
                      style={{
                       display: "flex",
                       flexWrap: "wrap",
                       justifyContent: "space-between",
                       alignItems: "center",
                       gap: "0px",
                      }}
                     >
                      <div style={{ flex: 1, minWidth: 0, marginTop: "10px" }}>
                       <h5
                        className="card-title mb-2 text-truncate"
                        style={{ maxWidth: "100%" }}
                       >
                        {rate.name}
                       </h5>

                       <p className="mb-1 text-wrap">
                        <span>
                         {rate.description && `${rate.description}, `}
                         {rate.selectedOption === "WEIGHT" &&
                          `Order weight from ${rate.minWeight ?? "N/A"} to ${rate.maxWeight ?? "N/A"}`}
                         {rate.selectedOption === "TOTAL_PRICE" &&
                          `Order total from ${rate.minprice ?? "N/A"} to ${rate.maxprice ?? "N/A"}`}
                        </span>
                       </p>
                      </div>

                      <div style={{ flexShrink: 0 }}>
                       <RateAction
                        rate={rate}
                        handleEditShippingRateClick={
                         handleEditShippingRateClick
                        }
                        handleshippingRateDelete={handleshippingRateDelete}
                       />
                      </div>
                     </div>
                    </div>
                   </div>
                  ))
                 ) : (
                  <div className="col-12">
                   <div className="alert alert-info text-center mb-0">
                    No rates available.
                   </div>
                  </div>
                 )}
                </div>
               </div>
              </td>
             </tr>
            )}
           </React.Fragment>
          ))
         ) : (
          <tr>
           <td colSpan="7" className="text-center">
            <h4>No data available</h4>
           </td>
          </tr>
         )}
        </tbody>
       </table>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default ShippingTable;
